// extracted by css-extract-rspack-plugin
export default {"column":"StatisticCard-module__column--B47Wk"};